import { paramCase } from 'change-case';
import orderBy from 'lodash/orderBy';

import { papers } from './papers';
import { REVIEW_ELEMENTS, REVIEW_STATES } from './consts';
import { users } from './users';
import { hashStringToNumber } from '../../utils/helpers';

function getMean(array) {
  const n = array.length;
  return array.reduce((a, b) => a + b) / n;
}
function getStandardDeviation(array) {
  const n = array.length;
  const mean = getMean(array);
  return Math.sqrt(array.map((x) => (x - mean) ** 2).reduce((a, b) => a + b) / n);
}

export function getAverageScores(paper) {
  const avgReview = {};
  const stdReview = {};
  REVIEW_ELEMENTS.forEach((key) => {
    avgReview[key] = getMean(paper.reviews.map((review) => review[key].finalScore));
    stdReview[key] = getStandardDeviation(paper.reviews.map((review) => review[key].finalScore));
  });
  const avgScore = getMean(Object.values(avgReview));
  return { avgReview, stdReview, avgScore };
}

function setAttributes(element, attributes) {
  Object.keys(attributes).forEach((attr) => {
    element[attr] = attributes[attr];
  });
}
function addAvgScoreField(paper) {
  paper.reviews.forEach((review) => {
    const avgFinalScore = getMean(REVIEW_ELEMENTS.map((type) => review[type].finalScore));
    review.average = { finalScore: avgFinalScore };
  });
}

function addHelperFields(papers) {
  papers.forEach((paper) => {
    if (
      paper.reviewState === REVIEW_STATES.AUTHOR_RESPONSE.name ||
      paper.reviewState === REVIEW_STATES.POST_REVIEW.name
    ) {
      const scores = getAverageScores(paper);
      setAttributes(paper, scores);
      addAvgScoreField(paper);
    }
    if (paper.reviewState !== REVIEW_STATES.POST_REVIEW.name) {
      // In the real version this would come from sever calc
      paper.matchScore = hashStringToNumber(paper.title, 30, 92);
      paper.rewardData = [42, hashStringToNumber(paper.title, 1, 30), hashStringToNumber(paper.title, 1, 10)];
    }
    paper.authorsData = paper.authors.map((user) => getUserByName(user));
  });
  return papers;
}

export function getAllPosssibleReviewStates() {
  return Object.keys(REVIEW_STATES)
    .map((state) => REVIEW_STATES[state])
    .filter((reviewState) => reviewState.display);
}

export function getAllPapers() {
  // Always work on a copy of original "DB"
  const papersCopy = papers.map((paper) => JSON.parse(JSON.stringify(paper)));
  addHelperFields(papersCopy);
  return papersCopy;
}

export function getReviewedPapers() {
  return getPapersInState(REVIEW_STATES.POST_REVIEW.name);
}

export function getAuthorReviewedPapers(author) {
  const reviewedPapers = getReviewedPapers();
  const authorPapers = reviewedPapers.filter((paper) => paper.authors.includes(author.displayName));
  return orderBy(authorPapers, (paper) => Date.parse(paper.reviewDate), ['desc']);
}

export function getReviewerBountyByPaperID(reviewer, paperID) {
  return reviewer.reviews.find((review) => review.paper === paperID).bounty;
}
export function getPapersInState(reviewState) {
  return getAllPapers().filter((paper) => paper.reviewState === reviewState);
}

export function getPapersByText(text, reviewState) {
  return getPapersInState(reviewState).filter((paper) => paper.title.toLowerCase().includes(text.toLowerCase()));
}

export function getPaperByID(arxivID) {
  // TODO: Check for errors?
  return getAllPapers().filter((paper) => paper.arxivID === arxivID)[0];
}

export function getPapersByReviewer(user) {
  // TODO: Check for errors?
  // TODO: Sort by start date!
  return user.reviews.map((review) => getPaperByID(review.paper));
}

export function getReviewerIndex(user, paper) {
  const reviewData = user.reviews.find((review) => review.paper === paper.arxivID);
  if (reviewData === undefined) {
    return -1;
  }
  return reviewData.reviewer_name;
}

function StateIsUnderReview(reviewState) {
  return reviewState !== REVIEW_STATES.PRE_REVIEW.name && reviewState !== REVIEW_STATES.POST_REVIEW.name;
}

export function getPapersUnderReviewByReviewer(user) {
  const papers = getPapersByReviewer(user);
  return papers.filter((paper) => StateIsUnderReview(paper.reviewState));
}

export function getPapersByAuthor(user) {
  return getAllPapers().filter((paper) => paper.authors.includes(user.displayName));
}

export function getSubmittedPapersByAuthor(user) {
  const papers = getPapersByAuthor(user);
  return papers.filter((paper) => paper.reviewState === REVIEW_STATES.PRE_REVIEW.name);
}

export function getUnderReviewPapersByAuthor(user) {
  const papers = getPapersByAuthor(user);
  return papers.filter(
    (paper) =>
      paper.reviewState !== REVIEW_STATES.POST_REVIEW.name && paper.reviewState !== REVIEW_STATES.PRE_REVIEW.name
  );
}

export function getReviewedPapersByReviewer(user) {
  const papers = getPapersByReviewer(user);
  return papers.filter((paper) => paper.reviewState === REVIEW_STATES.POST_REVIEW.name);
}

export function getAllUsers() {
  return users.slice();
}

export function getUserByName(userName) {
  let user = getAllUsers().filter((user) => user.displayName === userName)[0];
  if (user === undefined) user = { displayName: userName };
  return user;
}

export function getUserByRoutedName(userName) {
  return getAllUsers().filter((user) => paramCase(user.displayName) === userName)[0];
}

export function getLoggedUser() {
  return getUserByName('Et Al');
}

// getStandardDeviation(papers[0].reviews.map((review)=>review.novelty.score))
